import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    theme: {
      validations: []
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill in required field' },
      ]
    },
    reference: {
        validations: [
          { type: 'required', message: 'Please fill in required field' },
        ]
      },
      notes: {
        validations: []
      },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ] 
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventDate'
          }
        ]
      },
      {
    fields: [
      {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Event Type:',
        options: [
          { label: 'Bar Mitzvah', value: 'Bar Mitzvah'},
          { label: 'Bat Mitzvah', value: 'Bat Mitzvah'},
          { label: 'Wedding', value: 'Wedding'},
          { label: 'Bridal Shower', value: 'Bridal Shower'},
          { label: 'Baby Shower', value: 'Baby Shower'},
          { label: 'Other', value: 'Other'},          
        ],
        mapping: 'theme'
      }
    ]
  },
  {
    fields: [
      {
        type: 'text',
        size: 'Medium',
        label: 'Estimated Guest Count:*',
        mapping: 'plannedguestcount'
      }
    ]
  },
        {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How Did You Hear About Us?:*',
            options: [
              { label: 'Search Engine', value: 'Search Engine'},
              { label: 'Current Member', value: 'Current Member'},
              { label: 'Facebook', value: 'Facebook'},
              { label: 'Instagram', value: 'Instagram'},
              { label: 'Snapchat', value: 'Snapchat'},
              { label: 'Other', value: 'Other'},
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Preakness Hills Country Club Contact Form',
    formId: '2170',
    clientKey: '0D3DE0EC-5624-4AD6-A963-DF6766114F93',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText:'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    redirectUrl: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
